import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import Caution from "../../components/caution";
import MyLink from "../../components/myLink";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <EMTLevel level="basic" mdxType="EMTLevel">
  <ul>
    <li>
      <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
        1.0 Routine Patient Care
      </MyLink>
    </li>
    <li>Avoid Rough Movement and Prevent Further Heat Loss:</li>
    <li>Insulate from the ground and shield from wind/water</li>
    <li>Move to a warm environment as soon as practical</li>
    <li>Remove any wet clothing</li>
    <li>Cover with warm blankets, particularly the head</li>
    <li>
      Determine patient’s hemodynamic status: Assess pulse and respiratory rates
      for a period of 60 seconds to determine pulselessness or profound asystole, for
      which CPR would be required.
    </li>
    <li>
      If patient is in cardiopulmonary arrest, refer to:
      <ul>
        <li>
          <MyLink to="/sections/3/3.04A-asystole-pea" mdxType="MyLink">
            3.4A Cardiac Arrest - Asystole/Pulseless Electrical Activity
          </MyLink>
        </li>
        <li>
          <MyLink to="/sections/3/3.04P-asystole-pea" mdxType="MyLink">
            3.4P Cardiac Arrest - Asystole/Pulseless Electrical Activity
          </MyLink>
        </li>
        <li>
          <MyLink to="/sections/3/3.05A-vfib-pulseless-vtach" mdxType="MyLink">
            3.5A Cardiac Arrest - Ventricular Fibrillation/Pulseless Ventricular Tachycardia.
          </MyLink>
        </li>
        <li>
          <MyLink to="/sections/3/3.05P-vfib-pulseless-vtach" mdxType="MyLink">
            3.5P Cardiac Arrest - Ventricular Fibrillation/Pulseless Ventricular Tachycardia.
          </MyLink>
        </li>
      </ul>
    </li>
    <ul>
      <li>
        Initiate CPR and administer oxygen using appropriate oxygen delivery
        device, as clinically indicated.
      </li>
      <li>
        Use AED according to the ECC guidelines or as otherwise noted in these
        Protocols and other advisories.
      </li>
    </ul>
    <li>
      Whenever possible, use warmed, humidified oxygen (104°F – 107°F, 40°C –
      42°C) by non-rebreather mask, during resuscitation procedures for hypothermic
      patients.
    </li>
    <li>
      <strong>CAUTION:</strong> Do <strong>NOT</strong> administer anything orally if patient does not have a
      reasonable level of consciousness and normal gag reflex.
    </li>
    <li>
      Manage hypoglycemia and narcotic overdose per protocol.
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  Warm IV Fluids should be used.
    </EMTLevel>
    <EMTLevel level="paramedic" mdxType="EMTLevel">
  If pulse and breathing are absent, treat per Cardiac Arrest Protocols.
    </EMTLevel>
    <Caution id="caution-1" mdxType="Caution">
  Do NOT massage extremities in an attempt to actively rewarm the patient.
    </Caution>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      